import './DatePicker.component.scss';
import 'react-datepicker/dist/react-datepicker.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import es from 'date-fns/locale/es';
import en from 'date-fns/locale/uk';
import React, { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { change } from 'redux-form';

import { TLanguages } from '../../../domain/language.interface';
import { makeSelectLocale } from '../../../store/language-provider/language-provider.selectors';

registerLocale('es', es);
registerLocale('en', en);

export function DatepickerComponent(props: any) {
  const dispatch = useDispatch();
  const locale: TLanguages = useSelector(makeSelectLocale());
  const [initialDate, setInitialDate] = useState(
    !!props.initialDate ? props.initialDate : undefined,
  );
  const [date, setDate] = useState<any>(null);
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    if (!props.date) {
      return;
    } else {
      setDate(new Date(Date.parse(props.date)));
      setSelected(true);
    }
  }, [props.date]); // eslint-disable-next-line
  useEffect(
    () =>
      setInitialDate(
        !!props.initialDate
          ? new Date(Date.parse(props.initialDate))
          : undefined,
      ),
    [props.initialDate],
  );

  function handleRemoveSelection(e: any) {
    e.preventDefault();
    setDate(null);
    setSelected(false);
    dispatch(change(props.formName, props.input.name, null, false));
    if (!!props.setLimitDate) {
      props.setLimitDate(undefined, props.input.name);
    }
  }

  function handleOnChange(selectedDate: Date) {
    setDate(selectedDate);
    setSelected(true);
    if (!!props.setLimitDate) {
      props.setLimitDate(selectedDate, props.input.name);
    }
  }

  return (
    <React.Fragment>
      <div className={`${selected ? '' : 'hide'}`}>
        <FormattedDate
          value={date ? date : new Date()}
          year='numeric'
          month='long'
          day='2-digit'
        >
          {(formattedDate: any) => (
            <div className='minicard'>
              <div className='minicard-info'>
                <h6>{formattedDate}</h6>
                <p>
                  <FormattedMessage id={props.placeholder} />
                </p>
              </div>
              <div className='minicard-buttons'>
                <div
                  className='minicard-delete'
                  onClick={(e: any) => handleRemoveSelection(e)}
                >
                  <FontAwesomeIcon icon='trash' />
                </div>
              </div>
            </div>
          )}
        </FormattedDate>
      </div>
      <div className={`datepicker-container ${selected ? 'hide' : ''}`}>
        <FormattedMessage id={props.placeholder}>
          {(txt: any) => (
            <DatePicker
              {...props.input}
              selected={date}
              onSelect={(selectedDate: Date) => handleOnChange(selectedDate)}
              minDate={initialDate}
              maxDate={props.maxDate ? props.maxDate : undefined}
              locale={locale}
              isClearable
              showYearDropdown
              showMonthDropdown
              dropdownMode='select'
              placeholderText={txt}
              popperPlacement='bottom'
              popperModifiers={{
                flip: {
                  behavior: ['bottom'],
                },
                preventOverflow: {
                  enabled: false,
                },
                hide: {
                  enabled: false,
                },
              }}
              customInput={
                <div className='datepicker-input-container'>
                  <label htmlFor={props.input.name}>
                    <FontAwesomeIcon icon='calendar-day' size='3x' />
                    <p className='text-primary-lg font-weight-light'>{txt}</p>
                  </label>
                  <input name={props.input.name} className='datepicker-input' />
                </div>
              }
            />
          )}
        </FormattedMessage>
      </div>
    </React.Fragment>
  );
}
